import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const decodeToken = (token) => {
    try { return JSON.parse(atob(token.split('.')[1])); }
    catch { return null; }
};

const AdminProtectedRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    const location = useLocation();
    const hostname = window.location.hostname;
    const isAdminSubdomain = hostname.includes('admin.');

    if (!token) {
        const loginPath = isAdminSubdomain ? '/login' : '/admin/login';
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    const decoded = decodeToken(token);
    if (!decoded || decoded.role !== 'admin') {
        localStorage.removeItem('token');
        const loginPath = isAdminSubdomain ? '/login' : '/admin/login';
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    return children;
};

export default AdminProtectedRoute;
